var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 5.936 13.999"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 14a1 1 0 0 1-.837-1.547L3.74 6.97.165 1.55a1 1 0 0 1 1.67-1.1L5.77 6.415a1 1 0 0 1 .003 1.097l-3.935 6.033a.998.998 0 0 1-.838.453z"
  })));
};
export default SvgArrowRight;